import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '@packages/api';
import { getTrialBalance, listLedgers, type PeriodReportRange } from '@packages/api/endpoints/ledger.js';
import { getGroupedIncomeStatement } from '@packages/api/endpoints/account-group.js';
import type { PeriodPreset } from '@packages/types';

/** Members without accounting access get a 403 here: callers gate on `useAccountingAccess`. */
export function ledgersQueryOptions(accountId: string) {
  return queryOptions({
    queryKey: queryKeys.ledgers(accountId),
    queryFn: () => listLedgers(accountId),
    staleTime: 5 * 60_000,
  });
}

/** The current trial balance, which the accounting page reads to decide between setup and the tabs. */
export function trialBalanceQueryOptions(accountId: string, ledgerId: string) {
  return queryOptions({
    queryKey: queryKeys.trialBalance(accountId, ledgerId),
    queryFn: () => getTrialBalance(accountId, ledgerId),
  });
}

/** The period the income statement opens on. */
export const DEFAULT_INCOME_STATEMENT_PRESET: PeriodPreset = 'this-month';

export function groupedIncomeStatementQueryOptions(accountId: string, ledgerId: string, range: PeriodReportRange) {
  return queryOptions({
    queryKey: queryKeys.groupedIncomeStatement(accountId, ledgerId, range),
    queryFn: () => getGroupedIncomeStatement(accountId, ledgerId, range),
  });
}
